import {Component, forwardRef} from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';

class _sanitizedHtml extends Component {
  
  static propTypes = {
    /** By default the container of the sanitized Html is a <div>, but you can make this render as another component */
    as: PropTypes.elementType,
    /** The html to sanitize then set as inner HTML */
    html: PropTypes.string,
    /** class name forwarded to the container element */
    className: PropTypes.string,
    /** A react ref object to attach to the top level element */
    forwardedRef: PropTypes.any,
    /** A list of tag names to remove from the default array  of allowed tags */
    removeAllowedTags: PropTypes.arrayOf(PropTypes.string)
  };


  render() {
    const {as, html, className, forwardedRef} = this.props;
    const ContainerComponent = as || "div";
    
    return (
      <ContainerComponent 
        data-testid="sanitized-html-container"
        className={className} 
        dangerouslySetInnerHTML={{__html: this.customSanitizeHtml(html)}} 
        ref={forwardedRef}
      />
    );
  }

  customSanitizeHtml(input) {
    const {removeAllowedTags = []} = this.props;
    let defaultAllowedTags = [
      'b', 'em', 'i', 'u', 'small', 'strong', 'sub', 'sup', 'ins', 'del', 'mark', 'h3', 'h4', 'h5', 'h6', 'blockquote',
      'p', 'a', 'ul', 'ol', 'nl', 'li', 'strike', 'code', 'hr', 'br', 'caption', 'pre'
    ];
    let allowedTags = defaultAllowedTags.filter(tag => !removeAllowedTags.includes(tag));
    return DOMPurify.sanitize(input, {
      ALLOWED_TAGS: allowedTags
    });
  }
}

export const SanitizedHtml = forwardRef((props, ref) => {
  const SanitizeHtmlInnerComponent = _sanitizedHtml;
  return <SanitizeHtmlInnerComponent forwardedRef={ref} {...props}/>
});
